import { createStyles } from "antd-style";
const useStyles = createStyles(() => ({
  btn: {
    "height": "100%",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "padding": "0 12px",
    "cursor": "pointer",
    "&:hover": { background: "rgba(0, 0, 0, 0.06)" },
    "> span": {
      marginRight: "8px",
      width: "24px",
      height: "24px"
    }
  }
}));
var style_default = useStyles;
export {
  style_default as default
};
